import { Swiper, SwiperSlide, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

(function () {
  const breakpoint = window.matchMedia("(min-width:1024px)");

  let allSwipers;

  const breakpointChecker = function () {
    if (breakpoint.matches) {
      // Remove the slider and cleanup classes
      if (allSwipers !== undefined) {
        // We need to check if there are multiple swipers or just one
        if (typeof allSwipers.forEach !== "undefined") {
          allSwipers.forEach((swiper) => {
            // Classes need to be toggled before the slider is destroyed
            // otherwise it will trigger a bug
            toggleSwiperClasses(swiper.wrapperEl.parentElement, "off");
            swiper.destroy(true, true);
          });
        } else {
          toggleSwiperClasses(allSwipers.wrapperEl.parentElement, "off");
          allSwipers.destroy(true, true);
        }
      } else {
        // This is needed for when the slider isn't init already but
        // we still need to clean up the classes
        document.querySelectorAll(".swiper").forEach((swiper) => {
          toggleSwiperClasses(swiper, "off");
        });
      }
      return;
    } else if (breakpoint.matches === false) {
      // Enable the swiper on the mobile viewports
      return enableSwiper();
    }
  };

  const enableSwiper = function () {
    document.querySelectorAll(".swiper").forEach((swiper) => {
      const swiperInner = swiper;
      toggleSwiperClasses(swiperInner, "on");
    });

    allSwipers = new Swiper(".swiper", {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  };

  const toggleSwiperClasses = function (target, mode = "on") {
    if (mode === "on") {
      target.children[0].classList.remove("grid-cols-3");
      target.children[0].classList.add("swiper-wrapper");
      var slides = target.children[0].children;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.add("swiper-slide");
      }
      target.children[0].classList.add("!gap-0");
      if (target.querySelector(".swiper-pagination")) {
        target.querySelector(".swiper-pagination").classList.remove("hidden");
      }
    }

    if (mode === "off") {
      target.children[0].classList.add("grid-cols-3");
      target.children[0].classList.remove("swiper-wrapper");
      var slides = target.children[0].children;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove("swiper-slide");
      }
      target.children[0].classList.remove("!gap-0");
      if (target.querySelector(".swiper-pagination")) {
        target.querySelector(".swiper-pagination").classList.add("hidden");
      }
    }
  };

  breakpoint.addEventListener("change", (event) => {
    breakpointChecker();
  });

  breakpointChecker();
})();
